import styled from 'styled-components';
import Ico36 from 'dc/Ico36';
import { Typ42 } from 'dc/Typ';
import Lab010 from 'dc/Lab010';
import { LongWrapper } from '../elements';

export const Wrapper = styled(LongWrapper)`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-bottom: 1px solid #dbe1e5;
`;

export const Icon = styled(Ico36)`
  color: #00ab97;
`;

export const Title = styled(Typ42)`
  text-align: center;
`;

export const TimeLabel = styled(Lab010)``;
